import {Component, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {Amenity} from '../../../types/data.types';
import {AuthenticationService} from '../../../services/authentication.service';
import {AmenitiesService} from '../../../services/amenities.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'amenity-deposit-charge',
    templateUrl: './amenity-deposit-charge.component.html',
    styleUrls: ['./amenity-deposit-charge.component.scss']
})
export class AmenityDepositChargeComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    data: Amenity = new Amenity();
    disabledSubmit = false;
    amenityFees = [{name: '', amount: ''}];
    spinnerShow = false;

    constructor(
        public api: ApiClientService,
        public amenitiesService: AmenitiesService,
        public authService: AuthenticationService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.initData();
        setTimeout( () => this.showModal = true, 300);
    }

    initData() {
        this.spinnerShow = true;
        // this.data = Object.assign({}, this.amenitiesService.amenityInAmenityModal);
        // this.amenityFees = this.data.payments;
        this.spinnerShow = false;
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.amenitiesService.isAmenityDepositChargeShow = false;
                    this.amenitiesService.amenityInAmenityModal = null;
                }
            );
        } else {
            this.amenitiesService.isAmenityDepositChargeShow = false;
            this.amenitiesService.amenityInAmenityModal = null;
        }
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.amenitiesService.getData();
        this.form.reset();
        this.hideModal();
    }

    getTotalPaymentValue(): any {
        let returnValue = 0;
        this.amenityFees.forEach((charge) => {
            if(charge.amount)
                    returnValue += parseFloat(charge.amount.replace(',', '.'));
        });
        return parseFloat(returnValue.toString()).toFixed(2);
    }
    getServiceFee(): any {
        let returnValue = 0;
        if(this.getTotalPaymentValue() != '0.00')
            returnValue = (parseFloat(this.getTotalPaymentValue()) * 0.039) + 0.30;
        return parseFloat((returnValue).toString()).toFixed(2);
    }

    getFeeTotalWithService(): any {
        let returnValue = 0;
        if(this.getTotalPaymentValue() != '0.00')
            returnValue = parseFloat(this.getTotalPaymentValue()) + parseFloat(this.getServiceFee());
        return parseFloat(returnValue.toString()).toFixed(2);
    }

    getPaymentsFormatted(): Array<any> {
        return this.amenityFees.map(fee => ({
            name: fee.name,
            amount: fee.amount
        }));
    }

    onSubmit(form: NgForm) {
        const data = { payments: this.getPaymentsFormatted() };
        this.disabledSubmit = true;
        const url = `/v1/booking/${this.amenitiesService.amenityInAmenityModal.id}.json`;
        this.amenitiesService.api.patch('domainAmenities', url, data).subscribe(
            () => this.updateView('The Deposit Charge was successfully updated'),
            error => this.api.errorHandler(error, 'Update failed!'),
            () => this.disabledSubmit = false
        );
    }

    trackByFn(index, item) {
        return index; // or item.id
    }

    addNewFee(index) {
        this.amenityFees.splice(index + 1, 0, {name: '', amount: ''});
    }
    removeFee(index) {
        if(this.amenityFees.length > 1)
            this.amenityFees.splice(index, 1);
        else
            this.amenityFees = [{name: '', amount: ''}];
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/amenities/amenity-deposit-charge/amenity-deposit-charge.component.ts